<template lang="pug">
div
  #annotationmMap.comAll(v-dragDiv, v-show="!actionData.isMini")
    .title.moveDragDiv
      span {{ actionData.cnName }}
      i.el-icon-minus.minibtn(title="最小化", @click="miniCom")
      i.el-icon-close(title="关闭", @click="closeAdd")
    .nav
      notationAdd(ref="notationAdd", :type="type", @closeAdd="closeAdd", @closeAddComment="closeAddComment", @setCurText="setCurText", @startScreenShot="startScreenShot")
</template>

<script>
import notationAdd from "@/views/mongeView/question/notationAdd.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import kscreenshot from "@/CommonDP/utils/kscreenshot/src/kss.js";
import html2canvas from "html2canvas";
export default {
  components: { notationAdd },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      kissIndex: "",
      kss: ""
    };
  },
  methods: {
    // 文件截图
    async startScreenShot(index) {
      this.kss = new kscreenshot({
        endCB: (base64) => {
          // 获取的图片
          this.$refs.notationAdd.getAddCutPicList(base64, index);
        },
        cancelCB: () => {
          // debugger
        }
      });
      switch (this.type) {
        case "pdf": {
          const pdfBox = this.$parent.$parent.$refs.iframeID;
          pdfBox.contentWindow.postMessage("cut");
          window.cutCallback = (el) => {
            html2canvas(el, { useCORS: true, allowTaint: true }).then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          };
          break;
        }
        case "txt": {
          const txtBox = this.$parent.$parent.$refs.txt;
          html2canvas(txtBox, { useCORS: true }).then((canvas) => {
            this.kss.startScreenShot(canvas);
          });
          break;
        }
        case "image": {
          const imageBox = this.$parent.$parent.$refs.image;
          html2canvas(imageBox, { useCORS: true }).then((canvas) => {
            this.kss.startScreenShot(canvas);
          });
          break;
        }
        case 'office': {
            const officeBox = this.$parent.$parent.$refs.iframeID;
            const dom = officeBox.src.includes(location.host) ? officeBox?.contentWindow?.document.body : officeBox;
            html2canvas(dom, { useCORS: true })
              .then((canvas) => {
                this.kss.startScreenShot(canvas);
              });
            break;
        }
        case "onlyoffice": {
          const officeBox = window.frames["frameEditor"];
          const dom = frameEditor.location.host === location.host ? officeBox.document.body : officeBox.frameElement;
          html2canvas(dom, { useCORS: true }).then((canvas) => {
            this.kss.startScreenShot(canvas);
          });
          break;
        }
        default:
          break;
      }
    },

    setCurText(val) {
      mongeApiMlib.setMapText(val);
    },
    miniCom() {
      this.$emit("closeCom", "issue", true);
    },
    async closeAdd(logo,param) {
      if (logo) {
        await this.$emit("openOther", logo);
      } 
      await this.$emit("closeCom", "issue", false, param);
    },
    closeAddComment(data,createFlag) {
      console.log("syncComment issue-----");
      this.$emit("addComment", data, createFlag);
    }
  }
};
</script>

  <style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
  <style lang="scss" scoped>
#annotationmMap {
  position: absolute;
  top: 35px;
  right: 30px;
  width: 370px;
  height: calc(100% - 90px);
  max-height: 870px;
  overflow: hidden;
  .nav {
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
.next {
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 22px;
  height: 30px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 8px;
  line-height: 30px;
  bottom: 165px;
  cursor: pointer;
  right: 10px;
  z-index: 4;
  i {
    margin-left: 6px;
    font-size: 16px;
  }
}
</style>
